<ng-container
  *ngTemplateOutlet="hasMultipleLocation? multiple : single; context: { jobLocation: defaultLocation }"
>

</ng-container>
<ng-template #multiple>
  <span
    matTooltipClass="tootltip-locations"
    data-cy="job-locations-multiple-address"
    [matTooltipDisabled]="!showTooltip"
    [matTooltip]="locations | mojoLocation"
  >
    Multiple Locations
  </span>
</ng-template>
<ng-template
  #single
  let-location="jobLocation"
>
  <div
    *ngIf="!!location"
    class="label comma-separate"
  >
    <span [attr.data-cy]="'job-locations-single-address-' + location.id">
      {{location | mojoLocation}}
    </span>
  </div>
</ng-template>
